import {
  createFrontendPlugin,
  PageBlueprint,
  ApiBlueprint,
} from '@backstage/frontend-plugin-api';
import {
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { ecsScheduledTasksApiRef, EcsScheduledTasksClient } from './api';
import { RiCalendarScheduleLine } from '@remixicon/react';

const ecsScheduledTasksApi = ApiBlueprint.make({
  params: defineParams => defineParams({
    api: ecsScheduledTasksApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    factory: ({ discoveryApi, fetchApi }) =>
      new EcsScheduledTasksClient({ discoveryApi, fetchApi }),
  }),
});

const ecsScheduledTasksPage = PageBlueprint.make({
  params: {
    path: '/ecs-scheduled-tasks',
    title: 'ECS Tasks',
    icon: <RiCalendarScheduleLine />,
    loader: () =>
      import('./components/EcsScheduledTasksPage').then(
        m => <m.EcsScheduledTasksPage />,
      ),
  },
});

export default createFrontendPlugin({
  pluginId: 'ecs-scheduled-tasks',
  extensions: [ecsScheduledTasksApi, ecsScheduledTasksPage],
});
